// extracted by mini-css-extract-plugin
export default {"window":"UserGroupGrid_window__RiVYP"};